module.exports = __webpack_public_path__ + "img/s2remark.023485c4.png";